import { Amplify } from 'aws-amplify';
import { environment } from 'src/environments/environment';

// Returns the APP_INITIALIZER factory. Failures are swallowed so a Cognito misconfig
// cannot block bootstrap — the Duende stack stays usable when this fails.
export function configureAmplify(): () => Promise<void> {
  return async () => {
    try {
      Amplify.configure({
        Auth: {
          Cognito: {
            userPoolId: environment.cognito.userPoolId,
            userPoolClientId: environment.cognito.userPoolClientId,
          },
        },
      });
    } catch (err) {
      console.error('[amplify.config] Amplify.configure failed', err);
    }
  };
}
